<div class="row">
  <div class="col-md-1"></div>
  <div class="col-md-9">
    <div
      class="row heading"
      style="margin-bottom: 12px"
      [innerHTML]="translationCode['faq.header']"
    ></div>
    <div
      class="acc-container"
      *ngFor="let faq of mockData; let i = index"
      style="margin-bottom: 16px"
    >
      <accordion [title]="concatData(i, faq.ques)"
        ><div class="answer">{{ concatAns(faq.ans) }}</div></accordion
      >
    </div>
  </div>
</div>
